import { useState } from "react";

// View state that resets each session (CLAUDE.md, "Storage"): which groups are open or folded, and their
// order. update(patch) merges into it and saves it under `key`.
export function useViewState(key) {
  const load = () => { try { return JSON.parse(sessionStorage.getItem(key) || "{}"); } catch { return {}; } };
  const [view, setView] = useState(load);
  const update = (patch) => setView(prev => {
    const next = { ...prev, ...patch };
    try { sessionStorage.setItem(key, JSON.stringify(next)); } catch { /* private mode: keep it in memory */ }
    return next;
  });
  return [view, update];
}
